import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import { Patient } from '../../core/models/patient.model';

export const loadPatients = createAction(
  '[Patient] Load Patients',
  props<{ patients: Patient[] }>()
);

export const addPatient = createAction(
  '[Patient] Add Patient',
  props<{ patient: Patient }>()
);

export const upsertPatient = createAction(
  '[Patient] Upsert Patient',
  props<{ patient: Patient }>()
);

export const addPatients = createAction(
  '[Patient] Add Patients',
  props<{ patients: Patient[] }>()
);

export const upsertPatients = createAction(
  '[Patient] Upsert Patients',
  props<{ patients: Patient[] }>()
);

export const updatePatient = createAction(
  '[Patient] Update Patient',
  props<{ patient: Update<Patient> }>()
);

export const updatePatients = createAction(
  '[Patient] Update Patients',
  props<{ patients: Update<Patient>[] }>()
);

export const deletePatient = createAction(
  '[Patient] Delete Patient',
  props<{ id: string }>()
);

export const deletePatients = createAction(
  '[Patient] Delete Patients',
  props<{ ids: string[] }>()
);

export const clearPatients = createAction(
  '[Patient] Clear Patients'
);
